import { render, staticRenderFns } from "./QADetail.vue?vue&type=template&id=19d06a7b&scoped=true"
import script from "./QADetail.vue?vue&type=script&lang=js"
export * from "./QADetail.vue?vue&type=script&lang=js"
import style0 from "./QADetail.vue?vue&type=style&index=0&id=19d06a7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d06a7b",
  null
  
)

export default component.exports